var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiBrCaretCircleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "arrow-circle-down",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,24A12,12,0,1,1,24,12,12.013,12.013,0,0,1,12,24ZM12,3a9,9,0,1,0,9,9A9.011,9.011,0,0,0,12,3ZM6.269,11.6l5.087,5.154a.9.9,0,0,0,1.288,0L17.731,11.6a.924.924,0,0,0-.644-1.575H6.913A.924.924,0,0,0,6.269,11.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiBrCaretCircleDown);
export default __webpack_public_path__ + "static/media/fi-br-caret-circle-down.14c167e2f01e2077052091d58f0779e6.svg";
export { ForwardRef as ReactComponent };